export default __webpack_public_path__ + "images/1f820bfab90f83f3f7ed9abf6713bedd-sales_and_marketing.webp";